import React from 'react';
import { Modal } from 'react-bootstrap';

interface WindowHeaderProps {
  title: React.ReactNode;
  //? Ícone opcional antes do título (classe Font Awesome, ex.: 'fa-solid fa-folder')
  iconClass?: string;
  //? Ações extras à direita do título (ex.: Editar/Excluir no detalhe de documento)
  actions?: React.ReactNode;
  className?: string;
}

//* Cabeçalho padrão de todas as janelas (modais): azul, sem "X", título em caixa alta.
//* Fechar = clicar fora ou no botão Cancelar do rodapé (spec modal-standardization).
const WindowHeader: React.FC<WindowHeaderProps> = ({ title, iconClass, actions, className }) => (
  <Modal.Header className={`window-header text-white ${className ?? ''}`}>
    <Modal.Title className="d-flex align-items-center gap-2 text-uppercase fs-5 text-white text-truncate">
      {iconClass && <i className={iconClass} />}
      {title}
    </Modal.Title>
    {actions && <div className="d-flex align-items-center gap-2 ms-auto flex-shrink-0">{actions}</div>}
  </Modal.Header>
);

export default WindowHeader;
